import React from 'react';
import { SvgIcon } from '@material-ui/core'

const ProtectedCarHouse = (props) => (
  <SvgIcon
    viewBox="0 0 44.96 36.723"
    {...props}
  >
    <g transform="translate(-221.101 -427.289)">
      <path 
        d="M161.909,270.109l-21.644-11.1a1.126,1.126,0,0,0-1.093,0l-21.643,11.31a.561.561,0,0,0-.219.764l.547.982a.563.563,0,0,0,.765.218l21.1-11.007,21.1,10.8a.561.561,0,0,0,.763-.218l.548-.983a.562.562,0,0,0-.218-.765Zm-10.01,7.147-1.065-3.266a5.62,5.62,0,0,0-5.344-3.879H133.947a5.619,5.619,0,0,0-5.344,3.879l-1.065,3.266a5.613,5.613,0,0,0-3.556,5.217v8.992a3.376,3.376,0,0,0,3.372,3.371h1.124a3.375,3.375,0,0,0,3.372-3.371v-1.125h15.736v1.125a3.376,3.376,0,0,0,3.372,3.371h1.124a3.375,3.375,0,0,0,3.372-3.371v-8.992A5.613,5.613,0,0,0,151.9,277.256Zm-21.158-2.57a3.365,3.365,0,0,1,3.206-2.328h11.545a3.366,3.366,0,0,1,3.206,2.328l.706,2.167H130.034ZM129.6,291.465a1.125,1.125,0,0,1-1.125,1.124h-1.124a1.125,1.125,0,0,1-1.124-1.124v-1.125H129.6Zm23.6,0a1.125,1.125,0,0,1-1.125,1.124h-1.124a1.125,1.125,0,0,1-1.124-1.124v-1.125h3.372Zm0-5.62v2.248H126.231v-5.62A3.376,3.376,0,0,1,129.6,279.1h20.231a3.376,3.376,0,0,1,3.372,3.372Zm-5.114-5.057c-1.693,0-3.878,1.632-3.878,3.367,0,.841.411,2.253,3.166,2.253l.713-.007a2.825,2.825,0,1,0,0-5.613Zm0,3.926c-.219,0-.465.008-.713.008-.74,0-1.479-.063-1.479-.567,0-.673,1.315-1.681,2.192-1.681s1.461.448,1.461,1.12-.586,1.12-1.461,1.12Zm-16.747-3.926a2.825,2.825,0,1,0,0,5.613l.712.007c2.754,0,3.166-1.412,3.166-2.253,0-1.735-2.185-3.367-3.877-3.367Zm.712,3.934c-.246,0-.492-.008-.712-.008-.878,0-1.461-.448-1.461-1.12s.584-1.12,1.461-1.12,2.192,1.009,2.192,1.681c0,.5-.74.567-1.48.567Z" 
        transform="translate(103.861 168.419)"
      />
      <path 
        d="M0,0V25.339" 
        transform="translate(224.962 438.672)"
        style={{ fill: 'currentColor', stroke: 'currentColor', strokeWidth: '2.2px' }}
      />
      <path 
        d="M0,0V25.339" 
        transform="translate(262.97 438.672)"
        style={{ fill: 'currentColor', stroke: 'currentColor', strokeWidth: '2.2px' }}
      />
    </g>
  </SvgIcon>
);

export default ProtectedCarHouse;